import { useState } from "react";
import { connect } from "react-redux";

import { alterarToken, alterarWhiteLabel } from "./../../actions/actions";

import Section from "../../components/section";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// import "./../../App.css";
// import "bootstrap/dist/css/bootstrap.min.css";

/**
 * @param props - props recebidas pelo componente
 * @returns
 *
 * Componente de landing page.
 * Este componente exibe a página inicial do site, incluindo várias seções informativas e de produtos.
 */
const Landing = (props: any) => {
  //whitelabel
  const primaryColor = props.whitelabel.primaryColor
    ? "" + props.whitelabel.primaryColor
    : "#009881";
  const lightPrimaryColor = props.whitelabel.lightPrimaryColor
    ? props.whitelabel.lightPrimaryColor
    : "#00B196";
  const secondaryColor = props.whitelabel.secondaryColor
    ? "" + props.whitelabel.secondaryColor
    : "#002295";
  const lightSecondaryColor = props.whitelabel.lightSecondaryColor
    ? props.whitelabel.lightSecondaryColor
    : "#003CFF";
  const fontPrimaryColor = props.whitelabel.fontPrimaryColor
    ? props.whitelabel.fontPrimaryColor
    : "#182b8f";

  const fontSecondaryColor = props.whitelabel.fontSecondaryColor
    ? props.whitelabel.fontSecondaryColor
    : "#fff";
  const backgroundColor = props.whitelabel.backgroundColor
    ? props.whitelabel.backgroundColor
    : "#fff";

  const token = useState<any>(props.session.access_token);

  const textSectionBanner1 =
    "Garanta já o seu voucher com os melhores descontos do mercado! Não perca essa oportunidade!";

  const textSectionBanner2 = (
    <div style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
      <ul>
        <li style={{ marginBottom: "0.8rem" }}>
          <CheckCircleIcon
            sx={{ color: "var(--color-primaria)", mr: 2, fontSize: "1.9rem" }}
          />
          <b>Sem burocracia:</b> Resgate e utilize seus vouchers de forma
          simples e rápida.
        </li>

        <li style={{ marginBottom: "0.8rem" }}>
          <CheckCircleIcon
            sx={{ color: "var(--color-primaria)", mr: 2, fontSize: "1.9rem" }}
          />
          <b>Economize tempo:</b> Receba seu voucher instantaneamente e use
          quando quiser.
        </li>

        <li style={{ marginBottom: "0.8rem" }}>
          <CheckCircleIcon
            sx={{ color: "var(--color-primaria)", mr: 2, fontSize: "1.9rem" }}
          />
          <b>Mais economia:</b> Aproveite descontos exclusivos em diversos
          produtos e serviços.
        </li>

        <li style={{ marginBottom: "0.8rem" }}>
          <CheckCircleIcon
            sx={{ color: "var(--color-primaria)", mr: 2, fontSize: "1.9rem" }}
          />
          <b>Segurança garantida:</b> Seus vouchers são protegidos e válidos
          para uso imediato.
        </li>

        <li style={{ marginBottom: "0.8rem" }}>
          <CheckCircleIcon
            sx={{ color: "var(--color-primaria)", mr: 2, fontSize: "1.9rem" }}
          />
          <b>Flexibilidade total:</b> Utilize seus vouchers quando e onde
          quiser, sem complicações.
        </li>
      </ul>
    </div>
  );
  const textSectionCTA =
    "Entenda o fluxo de emissão do seu Certificado Digital";
  const textSectionFourth =
    "Após esses passos, o seu certificado estará pronto para uso.";

  return (
    <Section
      style={{ background: "#000" }}
      type={"first"}
      button={true}
      token={token}
    />
  );
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    alterarTokenItens(novoNumero: any) {
      const action = alterarToken(novoNumero);
      dispatch(action);
    },
    alterarWhitelabel(whitelabel: any) {
      const action = alterarWhiteLabel(whitelabel);
      dispatch(action);
    },
  };
};

function mapStateToProps(state: any) {
  return {
    whitelabel: state.whiteLabel,
    session: state.session,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
